import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
export const commentStyles = stylex.create({
  comments: { marginTop: spacing.space48 },
  commentsHeading: {
    margin: 0,
    marginBottom: spacing.space24,
    fontSize: fontSizes.title,
    fontWeight: 500,
  },
  comment: {
    paddingBlock: spacing.space16,
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderBottomColor: colors.border,
    minWidth: 0,
  },
  commentBody: {
    marginTop: spacing.space8,
    fontSize: fontSizes.reading,
    overflowWrap: "anywhere",
  },
  commentActions: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: spacing.space4,
  },
  replies: {
    marginLeft: {
      default: spacing.space8,
      "@media (min-width: 768px)": spacing.space16,
    },
    paddingLeft: {
      default: spacing.space8,
      "@media (min-width: 768px)": spacing.space12,
    },
    borderLeftWidth: 1,
    borderLeftStyle: "solid",
    borderLeftColor: colors.border,
  },
});
